let _firstSuccessfulRequest = false

/** Mark that at least one API request succeeded — safe to show connectivity errors now */
export const markFirstSuccessfulRequest = () => {
  _firstSuccessfulRequest = true
}

/** Only show connectivity errors after at least one API call has succeeded once in this session */
export const shouldReportConnectivityError = (): boolean => _firstSuccessfulRequest

/**
 * Detects if an error is caused by network/connectivity issues.
 * Only matches errors with explicit network-related messages — not generic TypeErrors.
 */
export const isNetworkError = (error: any): boolean => {
  if (!error) return false

  const message = (error?.message || '').toLowerCase()

  return (
    message.includes('failed to fetch') ||
    message.includes('network request failed') ||
    message.includes('load failed') ||
    message.includes('networkerror') ||
    message.includes('network error') ||
    message.includes('connection refused') ||
    message.includes('connection reset') ||
    message.includes('connection timed out') ||
    message.includes('network connection was lost') ||
    message.includes('internet connection') ||
    error?.code === 'ERR_NETWORK' ||
    error?.code === 'ECONNABORTED' ||
    error?.code === 'ECONNREFUSED' ||
    error?.code === 'ETIMEDOUT' ||
    error?.code === 'ENOTFOUND'
  )
}
